

import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useHistory } from "../../utils/router";
import { toast, getLink } from "../../utils/helpers";
import Loader from "../general/Loader";
import CompraRecurrenteForm from "./Form";

const Edit = () => {
    const history = useHistory();
    const { id } = useParams();
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const [initialData, setInitialData] = useState(null);

    React.useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            const res = await fetch(`/api/compra-recurrentes/${id}`);
            const data = await res.json();
            if (res.ok && data.data) {
                setInitialData(data.data);
            }
            setLoading(false);
        };
        fetchData();
    }, [id]);

    const handleSubmit = async (payload) => {
        setSaving(true);
        try {
            const response = await fetch(`/api/compra-recurrentes/${id}`, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                    // Agrega el token si es necesario
                },
                body: JSON.stringify(payload)
            });
            const data = await response.json();
            if (response.ok && data.data) {
                toast("Compra recurrente actualizada con éxito");
                history.push(getLink("/compras-recurrentes"));
            } else {
                toast("Error al actualizar compra recurrente", "error");
            }
        } catch (e) {
            toast("Error de red", "error");
        }
        setSaving(false);
    };

    if (loading || !initialData) return <Loader />;

    return (
        <div className="crear-compra">
            <div className="page-header">
                <h1 className="page-title row">
                    <div className="col">
                        <span className="m-r-15">Editar Compra Recurrente</span>
                    </div>
                </h1>
            </div>
            <CompraRecurrenteForm initialData={initialData} onSubmit={handleSubmit} saving={saving} />
        </div>
    );
};

export default Edit;
